import React  from 'react';
import { Modal } from 'reactstrap';

import { 
  ContentModal,
  ContentMensajeExito
} from "./Estilos";

import { SecondaryButtonIrAlInicio } from "../Buttons/Buttons";

const ModalExito = ({titulo, message, icono, data}) => {
  
  return (
    <ContentModal>
      <Modal isOpen={data}>
        <ContentMensajeExito>
          <div>
            <i className={icono}></i>
          </div>
          <div>
            <h2>{titulo}</h2>
          </div>
          <div>
            <p>{message}</p>
          </div>

          <div className="row">
            <div className="col-md-6 mx-auto">
              <SecondaryButtonIrAlInicio />
            </div>
          </div>


        </ContentMensajeExito>
          
      </Modal>
    </ContentModal>

  )
}

export default ModalExito